export const NOTIFICACOES_DIA_SOURCE = {
  CARD: "card",
  MENU: "menu",
};

/**
 * Opens "Notificações do Dia" as its own route.
 * @param {object} router Vue Router instance
 * @param {{ source?: 'card'|'menu' }} [options]
 *   - menu: normal screen (no X)
 *   - card (Host Ver mais): fullscreen view with X that returns to previous page
 */
export function openNotificacoesDia(router, options = {}) {
  if (!router) {
    return;
  }
  const source =
    options.source === NOTIFICACOES_DIA_SOURCE.CARD
      ? NOTIFICACOES_DIA_SOURCE.CARD
      : NOTIFICACOES_DIA_SOURCE.MENU;

  const query = source === NOTIFICACOES_DIA_SOURCE.CARD ? { from: "card" } : {};
  const route = router.currentRoute;

  if (route && route.name === "NotificacoesDia") {
    const currentFrom = route.query && route.query.from;
    const nextFrom = query.from || undefined;
    if (currentFrom === nextFrom || (!currentFrom && !nextFrom)) {
      return;
    }
    router.replace({ name: "NotificacoesDia", query }).catch(() => {});
    return;
  }

  router.push({ name: "NotificacoesDia", query }).catch(() => {});
}
